// extracted by mini-css-extract-plugin
module.exports = {"container":"RaceRules__container--3S1","title":"RaceRules__title--2VI","content":"RaceRules__content--wLW","button":"RaceRules__button--20I"};